import { memo } from 'react';
import classNames from 'classnames';
import { Typography } from '../../../../../components/typography/typography';
import { FieldCounter } from '../../../../../components/field/field';
import styles from './product-item.module.css';
import { ProductItemDataReturn, ProductItemState } from '../../hooks/use-product-item-data';

interface ProductItemQuantityProps extends Pick<ProductItemState, 'quantity' | 'isRental' | 'isEditing'> {
  updateInputItem: ProductItemDataReturn['updateInputItem'];
}

export const ProductItemQuantity = memo<ProductItemQuantityProps>(
  ({ quantity, isRental, isEditing, updateInputItem }) => {
    if (isEditing) {
      return (
        <div>
          <FieldCounter
            value={quantity}
            onChange={(value) => updateInputItem({ quantity: value })}
            min={!isRental ? 0 : undefined}
            allowDecimals={!isRental}
          />
        </div>
      );
    }

    return (
      <Typography
        type="text-sm"
        weight="regular"
        className={classNames(styles.fieldContentText)}
        dataCy="product-item-quantity"
      >
        {quantity}
      </Typography>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.quantity === nextProps.quantity && prevProps.isEditing === nextProps.isEditing;
  },
);

ProductItemQuantity.displayName = 'ProductItemQuantity';
